import React from "react";
import { css } from "emotion";
import {boxStyles, colors, textSizes} from "../styles/theme";

const ErrorMessage = ({ children }) => {
  return (
    <div className={container}>{children}</div>
  );
};

export default ErrorMessage;

const container = css`
  color: ${colors.cancel};
  margin-bottom: -10px;
  font-size: ${textSizes.intermediate};
`;
